// Slim full-width top bar showing the current environment (local / staging).
// Auto-detected from the Supabase URL so it can never drift from config.
// Production deliberately shows nothing — absence of a bar means "this is live".
//
// Rendered as a normal in-flow block at the very top of the page (above the
// sticky <Header>). It scrolls away with the page top; the header then pins to
// the viewport on scroll as usual. In-flow = it can never overlap the header.

const STAGING_REF = "ouwpkicncexuwxgpwbjp";

type Env = "local" | "staging" | "production";

function detectEnv(): Env {
  const url = import.meta.env.VITE_SUPABASE_URL ?? "";
  if (url.includes("localhost") || url.includes("127.0.0.1")) return "local";
  if (url.includes(STAGING_REF)) return "staging";
  return "production";
}

const STYLES: Record<Exclude<Env, "production">, { label: string; bg: string }> = {
  local: { label: "🟡 LOCAL DEVELOPMENT", bg: "bg-yellow-400 text-black" },
  staging: { label: "🔴 STAGING", bg: "bg-red-600 text-white" },
};

export function EnvBanner() {
  const env = detectEnv();
  if (env === "production") return null;

  const { label, bg } = STYLES[env];

  return (
    <div
      className={`flex h-7 w-full items-center justify-center text-[11px] font-bold uppercase tracking-widest ${bg}`}
    >
      {label}
    </div>
  );
}
